import React, { PureComponent } from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';

import Auth from '../../libs/Auth';

import Products from './Listings';
import Accounts from './Accounts';
import Transactions from './Transactions';
import PriceChanges from './PriceChanges';
import Accepted from './OAuth/Accepted';

class EbayView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    const { match, logout, rateLimitRemaining } = this.props;
    return (
      <div>
        <ul className="menu">
          <li>
            <NavLink to="/ebay" exact={true} activeClassName="is-active">Accounts</NavLink>
          </li>
          <li>
            <NavLink to="/ebay/products" activeClassName="is-active">Listings</NavLink>
          </li>
          <li>
            <NavLink to="/ebay/transactions" activeClassName="is-active">Transactions</NavLink>
          </li>
          <li>
            <NavLink to="/ebay/priceChanges" activeClassName="is-active">Price Changes</NavLink>
          </li>
        </ul>
        <ul className="menu align-right logout-menu">
          <li>
            <NavLink to="/workArea" activeClassName="is-active">Trading</NavLink>
          </li>
        </ul>
        <div className="rate-limit-remaining">{rateLimitRemaining}</div>
        <Switch>
          <Route path={`${match.url}`} exact component={Accounts}/>
          <Route path={`${match.url}/accepted`} component={Accepted}/>
          <Route path={`${match.url}/products`} component={Products}/>
          <Route path={`${match.url}/transactions`} component={Transactions}/>
          <Route path={`${match.url}/priceChanges`} component={PriceChanges}/>
        </Switch>
      </div>
    )
  }
}

export default EbayView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Ebay.view.js